// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"206":"locale-gu","403":"locale-hi","875":"locale-mr"}[chunkId] || chunkId) + "." + {"206":"3d422d9b","403":"2524e81f","488":"1d53232d","875":"10190f57"}[chunkId] + ".chunk.js";
};